// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".M4LddhvT9cJ6zjVZWwNt{display:flex;flex-direction:column;width:100%}.M4LddhvT9cJ6zjVZWwNt ._JmjgvHiJlcNTxxYoHB3{margin-bottom:2.5rem}", "",{"version":3,"sources":["webpack://./src/Profile_V2/Components/Inventory/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,UAAA,CACA,4CACE,oBAAA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  .category {\n    margin-bottom: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "M4LddhvT9cJ6zjVZWwNt",
	"category": "_JmjgvHiJlcNTxxYoHB3"
};
export default ___CSS_LOADER_EXPORT___;
